<template>
  <div>
    <el-card class="page-container">
      <el-row class="title-biaoti">用户余额操作</el-row>
      <el-row class="search">
        <el-date-picker
          v-model="search.time"
          type="daterange"
          align="right"
          unlink-panels
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          :picker-options="retainedOptions"
          value-format="yyyy-MM-dd"
        >
        </el-date-picker>
        <el-input
          type="text"
          v-model="search.rid"
          placeholder="请输入主播id"
          clearable
        ></el-input>
        <el-select
          v-model="search.actType"
          placeholder="金币操作类型"
          style="width: 300px"
          filterable
          clearable
        >
          <el-option
            v-for="(item, itemIndex) in actTypelist"
            :key="itemIndex"
            :label="item.actTypeDesc"
            :value="item.actType + '，' + item.segmentCode + '，' + itemIndex"
          ></el-option>
        </el-select>
        <el-select v-model="search.action" placeholder="操作类型" filterable clearable>
          <el-option
            v-for="(item, itemIndex) in actionlist"
            :key="itemIndex"
            :label="item"
            :value="itemIndex + 1"
          ></el-option>
        </el-select>
        <el-select
          v-model="search.currencyCode"
          placeholder="货币类型"
          filterable
          clearable=""
        >
          <el-option
            v-for="(item, itemIndex) in currencylist"
            :key="itemIndex"
            :label="item.currencyType"
            :value="item.currencyCode"
          ></el-option>
        </el-select>
        <el-button type="primary" @click="query" :loading="login">查询 </el-button>
        <!-- <el-button type="danger" @click="operate(1)">新 增 </el-button> -->
        <el-button type="warning" @click="DownloadFile" :loading="login1"
          >下 载
        </el-button>
      </el-row>
      <el-row>
        <el-table :data="datalist" style="width: 100%" v-loading="login" stripe border>
          <el-table-column prop="userRid" label="用户id"> </el-table-column>
          <el-table-column prop="name" label="昵称"> </el-table-column>
          <el-table-column prop="gender" label="用户类型">
            <template slot-scope="scope">
              {{ scope.row.gender == 1 ? "用户" : "主播" }}</template
            >
          </el-table-column>
          <el-table-column prop="actionStr" label="操作类型"> </el-table-column>
          <el-table-column prop="actTypeStr" label="金币操作类型"> </el-table-column>
          <el-table-column prop="actDesc" label="描述"> </el-table-column>
          <el-table-column prop="beforeChange" label="变化前的值"> </el-table-column>
          <el-table-column prop="changed" label="变化的值"> </el-table-column>
          <el-table-column prop="afterChange" label="变化后的值"> </el-table-column>
          <el-table-column prop="changeRelation" label="变化关联"> </el-table-column>
          <el-table-column prop="otherRid" label="关联rid"> </el-table-column>
          <el-table-column prop="relatedId" label="关联事件id"> </el-table-column>
          <el-table-column prop="currencyCode" :formatter="formatCurrencyCode" label="货币码"> </el-table-column>
          <el-table-column prop="currencyType" label="货币类型"> </el-table-column>
          <el-table-column prop="createDate" label="创建时间"> </el-table-column>
          <el-table-column prop="operator" label="操作人"> </el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button type="danger" @click="operate(2, scope.row.rid)" size="mini"
                >删除
              </el-button>
            </template></el-table-column
          >
        </el-table>
      </el-row>
      <el-row>
        <el-pagination
          @current-change="handleCurrent"
          :current-page="pageInfo.page"
          :page-size="pageInfo.size"
          layout="total,prev, pager, next, jumper"
          :total="pageInfo.total"
        >
        </el-pagination>
      </el-row>
      <el-dialog
        title="新增金币流水记录"
        :visible.sync="dialog"
        width="50%"
        :before-close="handleClose"
      >
        <div class="item">
          <span>主播id：</span><el-input type="text" v-model="data.rid"></el-input>
        </div>
        <div class="item">
          <span>操作类型：</span
          ><el-select v-model="data.action" placeholder="操作类型" filterable clearable>
            <el-option
              v-for="(item, itemIndex) in actionlist"
              :key="itemIndex"
              :label="item"
              :value="itemIndex + 1"
            ></el-option>
          </el-select>
        </div>

        <div class="item">
          <span>金币操作类型：</span>
          <el-select
            v-model="data.actType"
            placeholder="金币操作类型"
            filterable
            clearable
          >
            <el-option
              v-for="(item, itemIndex) in actTypelist1"
              :key="itemIndex"
              :label="item.actTypeDesc"
              :value="item.actType"
            ></el-option>
          </el-select>
        </div>
        <div class="item">
          <span>值：</span><el-input type="text" v-model="data.value"></el-input>
        </div>
        <div class="item">
          <span>货币类型：</span>
          <el-select
            v-model="data.currencyCode"
            placeholder="货币类型："
            filterable
            clearable
          >
            <el-option
              v-for="(item, itemIndex) in currencylist"
              :key="itemIndex"
              :label="item.currencyType"
              :value="item.currencyCode"
            ></el-option>
          </el-select>
        </div>

        <div class="item">
          <span>描述：</span><el-input type="text" v-model="data.desc"></el-input>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="operate(3)" type="primary"> 新 增 </el-button>
          <el-button @click="handleClose">取 消</el-button>
        </span>
      </el-dialog>
    </el-card>
  </div>
</template>

<script>
import { downloadFile } from "@/utils/downloadFile.js";
import { datainfor } from "@/utils/formdata.js";
export default {
  data() {
    return {
      login: false,
      login1: false,
      datalist: [],
      dialog: false,
      type: true,
      search: {
        time: [datainfor(0), datainfor(0)],
        rid: "",
        actType: "",
        action: "",
        currencyCode: "",
      },
      data: { rid: "", action: "", value: "", actType: "", desc: "", currencyCode: "" },
      retainedOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
      },
      actionlist: ["增加", "扣减"],
      currencylist: [],
      pageInfo: {
        page: 1,
        total: 0,
        size: 30,
      },
      actTypelist: [],
      actTypelist1: [],
    };
  },
  created() {
    // this.query();
    this.currencyQuery();
    this.actTypeQuery(1);
  },
  methods: {
    formatCurrencyCode(row) {
      const array = [
        {
          name:"default",
          value:0
        },{
          name:"金币",
          value:1
        },{
          name:"钻石",
          value:2
        },{
          name:"游戏积分",
          value:3
        },
        {
          name:"游戏货币",
          value:4
        },
      
      ]
      return array.find(item => item.value == row.currencyCode)?.name || "default";
    },
    async currencyQuery() {
      const { data: res } = await this.$axios({
        type: "GET",
        url: this.$store.getters.path.config_currency_query,
        withCredentials: true,
        params: {
          username: this.$store.getters.username,
          token: this.$store.getters.token,
        },
      });
      this.currencylist = res.data.data;
    },
    async actTypeQuery(type) {
      const { data: res } = await this.$axios({
        type: "GET",
        url: this.$store.getters.path.money_operator_config,
        withCredentials: true,
        params: {
          username: this.$store.getters.username,
          token: this.$store.getters.token,
          isOperator: type,
        },
      });
      type == 1
        ? (this.actTypelist = res.data.data)
        : (this.actTypelist1 = res.data.data);
    },
    async query() {
      this.login = true;
      if(!this.search.time[0] || !this.search.time[1]){
        this.$message.error("请选择日期")
        this.login = false;
        return
      }
      if(!this.search.rid){
        this.$message.error("请输入主播id")
        this.login = false;
        return
      }
      const { data: res } = await this.$axios({
        type: "GET",
        url: this.$store.getters.path.money_operator_history_query,
        withCredentials: true,
        params: {
          username: this.$store.getters.username,
          token: this.$store.getters.token,
          page: this.pageInfo.page,
          startDate: this.search.time[0],
          endDate: this.search.time[1],
          rid: this.search.rid,
          action: this.search.action,
          actType: this.search.actType.split("，")[0],
          currencyCode: this.search.currencyCode,
          segmentCode: this.search.actType.split("，")[1],
        },
      });
      this.login = false;
      if (res.code != 0) return this.$message(res.msg);
      this.datalist = res.data.data;
      this.pageInfo.total = res.data.total;
    },
    handleCurrent(newpage) {
      this.pageInfo.page = newpage;
      this.query();
    },
    async operate(type, obj) {
      if (type == 1) {
        this.dialog = true;
        this.actTypeQuery(0);
      } else if (type == 2) {
        this.$prompt("请输入密码", "确认", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          inputType: "password",
        })
          .then(async ({ value }) => {
            const { data: res } = await this.$axios(
              this.$store.getters.path.money_operator_history_delete +
                "?username=" +
                this.$store.getters.username +
                "&token=" +
                this.$store.getters.token +
                "&id=" +
                obj +
                "&pws=" +
                value +
                "&ctime=" +
                Date.parse(new Date()) / 1000,
              {}
            );
            if (res.code !== 0) return this.$message.error("删除失败");
            this.$message.success("删除成功");
            this.query();
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: "已取消删除",
            });
          });
      } else if (type == 3) {
        const { data: res } = await this.$axios({
          type: "GET",
          url: this.$store.getters.path.money_operator_history_operator,
          withCredentials: true,
          params: {
            username: this.$store.getters.username,
            token: this.$store.getters.token,
            rid: this.data.rid,
            action: this.data.action,
            value: this.data.value,
            actType: this.data.actType,
            desc: this.data.desc,
            currencyCode: this.data.currencyCode,
          },
        });
        this.handleClose();
        if (res.code != 0) return this.$message(res.msg);
        this.$message.success("操作成功");
        this.query();
      }
    },
    // 下载
    async DownloadFile() {
      if(!this.search.rid){
        this.$message.error("请输入主播id")
        this.login = false;
        return
      }
      this.login1 = true;
      const res = await this.$axios({
        method: "GET",
        url: this.$store.getters.path.money_operator_history_dwn,
        withCredentials: true,
        headers: {
          "Content-Type": "application/json",
        },
        responseType: "blob",
        params: {
          username: this.$store.getters.username,
          token: this.$store.getters.token,
          page: this.pageInfo.page,
          startDate: this.search.time[0],
          endDate: this.search.time[1],
          rid: this.search.rid,
          actType: this.search.actType,
          action: this.search.action,
          currencyCode: this.search.currencyCode.split(",")[0],
          segmentCode: this.search.currencyCode.split(",")[1],
        },
      });

      this.$message.success("开始下载");
      this.login1 = false;
      downloadFile(res.data, "用户余额操作数据");
    },
    handleClose() {
      this.data = {
        rid: "",
        action: "",
        value: "",
        actType: "",
        desc: "",
        currencyCode: "",
      };
      this.dialog = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.search {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  > * {
    margin: 2px 3px;
  }
  .el-input {
    max-width: 200px;
  }
  .el-select {
    width: 200px;
  }
}
.item {
  display: flex;
  align-items: center;
  padding: 5px 0;
  span {
    white-space: nowrap;
    padding: 0 5px;
  }
}
</style>
